import Model from '$dependencies/Model';

const FIELDS = {
	id: { type: String, default: '', identifier: true },
	coordinates: { type: Object, default: () => {} },
	name: { type: String, default: '' },
	statusColor: { type: String, default: '' },
	postCode: { type: String, default: '' },
	parentModel: { type: Object, default: () => {} },
};

export default class IncidentMarkerModel extends Model {
	constructor(args = {}) {
		args = Object.assign({}, args);
		args.fields = FIELDS;
		super(args);
	}

	destroy() {}
}
